import React from 'react';
import PropTypes from 'prop-types';

const ENTER_KEY = 13;
const rgx = /^[0-9]*\.?[0-9]*$/;

export default class TextInput extends React.Component {

  inputElement = React.createRef();

  state = {
    value: this.props.value,
    editing: false,
    numberInput: false
  };

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onRealChange: PropTypes.func,
    onBlur: PropTypes.func,
    className: PropTypes.string,
    numberInput: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string,
    autoComplete: PropTypes.string,
    maxValue: PropTypes.number,
    usePropsValue: PropTypes.bool,
    placeholder: PropTypes.string,
    autoFocus: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  onChange = (event) => {
    let value = event.target.value;

    if (!value.match(rgx) && this.props.numberInput) {
      return false;
    }
    if (this.props.numberInput && this.props.maxValue && (this.getUpdatedValue(value) >= this.props.maxValue)) {
      value = this.props.maxValue;
    }
    this.setState({
      value
    });
    if (this.props.onRealChange) {
      this.props.onRealChange(value);
    }
  };

  onBlur = (event) => {
    let value = event.target.value;
    this.finishEditing(value);
    if (this.props.onBlur) {
      this.props.onBlur(value);
    }
  };

  getUpdatedValue = (value) => {
    if (!this.props.numberInput) {
      return value
    }
    if (value.indexOf('.') === 0) {
      value = +("0"+value);   // dot on the beginning
    }
    if (value.toString().indexOf(".") === (value.toString().length - 1)) {
      value = value.substring(0, value.length - 1); // dot on the end
    }
    if (this.props.maxValue && (+value > this.props.maxValue)) {
      value = this.props.maxValue;
    }
    return +value || 0
  }

  finishEditing = (value) => {
    value = this.getUpdatedValue(value);
    this.setState({
      editing: false
    }, () => {
      this.props.onChange(value);
    })
  };

  onFocus = () => {
    let value = this.props.numberInput && this.props.currencySing
      ? this.props.value.replace(this.props.currencySing,"").replace("%","").replace(",","").replace("x","")
      : this.props.value;
    value = (value === "Included" ? "" : value);
    this.setState({
      editing: true,
      value
    });
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  };

  handleKeyDown = e => {
    if (e.keyCode === ENTER_KEY) {
      // this.finishEditing(this.state.value);
      e.target.blur();
    }
  };

  render() {
    return <input className={this.props.className || "ui-input ui-input--gray2" + (this.state.editing ? " ui-input--editing" : "")}
                  autoComplete={this.props.autoComplete}
                  onChange={this.onChange}
                  autoFocus={this.props.autoFocus}
                  disabled={this.props.disabled}
                  onBlur={this.onBlur}
                  onFocus={this.onFocus}
                  onKeyDown={this.handleKeyDown}
                  onClick={this.props.onClick || null}
                  placeholder={this.props.placeholder || null}
                  id={this.props.id || null}
                  name={this.props.name || this.props.placeholder || null}
                  ref={this.inputElement}
                  value={this.state.editing && !this.props.usePropsValue ? this.state.value : this.props.value}/>
  }
}
